import { i18n } from '../../i18n/translate';

export const unauthenticatedCustomerNavigation = () => {
  return {
    id: 'foundry--universal_navigation--menus--unauthenticated_customer_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--unauthenticated_customer_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [
      {
        id: '',
        slug: '',
        title: i18n.t('Help'),
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        target_url: `https://support.everfi.com`,
        target_method: '',
        new_window: true,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        title: i18n.t('Language'),
        icon: 'language',
        font_family: '',
        css_class: '',
        comment: 'open a modal.',
        target_url: `language_modal`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
    ],
  };
};
